import React from 'react';
import { useLocation } from 'react-router-dom';
import { CardHeader } from '@material-ui/core';
import { Card, CardHeaderTitle, PlainLink } from '../../../../ui-kit';
import { routePaths } from '../../../../routePaths';

interface WarehouseCategoriesDetailCardProps {
    id: string;
    name: string;
}

const WarehouseCategoriesDetailCard = ({ name, id }: WarehouseCategoriesDetailCardProps) => {
    const location = useLocation();
    return (
        <PlainLink
            to={{
                pathname: `${routePaths.warehouseCategories}/${id}`,
                state: { background: location }
            }}
        >
            <Card>
                <CardHeader
                    disableTypography
                    title={(
                        <CardHeaderTitle>
                            {name}
                        </CardHeaderTitle>
                    )}
                />
            </Card>
        </PlainLink>
    );
};

export default WarehouseCategoriesDetailCard;
